import angular from 'angular'
import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import {
  QuickReceipt,
  QuickReceiptListItem,
  QuickReceiptDateItem,
  QuickReceiptRegisterItem,
} from '../quick-receipt/QuickReceipt'
import { useCashMovementsTypes } from '../../cash-management/utils/useCashMovementTypes'
import { useFormatCurrencyValue } from '../../helpers/formatNumberHooks'

interface CashMovementData {
  amount: string
  date: string
  note?: string
  type: string
  username: string
}

interface CashMovementReceiptProps {
  data: CashMovementData
}

export const CashMovementReceipt: React.FC<CashMovementReceiptProps> = ({
  data,
}) => {
  const formatCurrencyValue = useFormatCurrencyValue()
  const t = useT()
  const cashMovementTypes = useCashMovementsTypes()

  return (
    <QuickReceipt
      title={cashMovementTypes(data.type)}
      subTitle={formatCurrencyValue(data.amount)}
      items={
        <>
          <QuickReceiptDateItem value={data.date} />
          <QuickReceiptListItem label={t('User')} value={data.username} />
          <QuickReceiptRegisterItem />
          <QuickReceiptListItem label={t('Note')} value={data.note || '-'} />
        </>
      }
    />
  )
}

angular
  .module('webregister.components')
  .component(
    'wrPrintCashMovementReceipt',
    reactular(CashMovementReceipt, ['data'], 'reactWrapper')
  )
